import withLanguage from "../HOC/withLanguage";

const legalSectionsConfig = [
  {
    titleKey: "laws",
    items: [
      {
        key: "list2",
        url: "https://qbz.gov.al/eli/ligj/1995/07/11/7961/0d524177-6a90-4e35-9ebc-142e1cab7d19",
      },
      {
        key: "list_kodi_procedurave",
        url: "https://qbz.gov.al/eli/ligj/2015/04/30/44/49b2fb39-de15-4b0b-a030-487b57c57a85",
      },
      {
        key: "list3",
        url: "https://qbz.gov.al/eli/ligj/2012/09/27/90/a92a9d14-7ba9-4ada-bbe6-2fe3d8395384",
      },
      {
        key: "list4",
        url: "https://qbz.gov.al/eli/ligj/2010/07/08/10296/27de5875-ca02-4182-a2fa-86c3522997c1",
      },
      {
        key: "list5",
        url: "https://qbz.gov.al/eli/ligj/2005/04/07/9367/79855513-fa37-4a8a-8a66-b29571104d09",
      },
      {
        key: "list6",
        url: "https://qbz.gov.al/eli/ligj/2003/09/08/9131/2e8d633e-3feb-4dfc-ad05-5308f415b83b",
      },
      {
        key: "list7",
        url: "https://qbz.gov.al/preview/f5b3bd78-80cf-4fb0-8037-7700f3b9e139/cons/20231108",
      },
      {
        key: "list8",
        url: "https://qbz.gov.al/preview/fa1672dd-ab57-4965-8113-f8778241716f/cons/20230724",
      },
      {
        key: "list9",
        url: "https://qbz.gov.al/preview/8fba0dc9-db24-43b5-9e8a-cf49afa481c4/cons/20170506",
      },
      {
        key: "list_afp_2017",
        url: "https://qbz.gov.al/preview/df984385-d214-41eb-9f15-069ff13e7318/cons/20240424",
      },
      {
        key: "list18",
        url: "https://qbz.gov.al/eli/ligj/2021/06/24/79/a2ff0be0-d4a8-4089-94c4-3a7ba1846a9b",
      },
      {
        key: "list_vullnetarizmi",
        url: "https://qbz.gov.al/eli/ligj/2016/04/28/45/5e164331-4d77-4a80-abf9-7973591b5d9d",
      },
      {
        key: "list17",
        url: "https://qbz.gov.al/eli/ligj/2015/12/17/146/1eed6a13-a9ff-401f-854d-1066bb121a97",
      },
      {
        key: "list_korniza_kualifikimeve",
        url: "https://qbz.gov.al/preview/c6554ce0-27c8-46e2-8c10-2fb908fa03f3/cons/20180614",
      },
      {
        key: "list_zejtaria",
        url: "https://qbz.gov.al/eli/ligj/2016/06/30/70-2016/648126e8-1034-459b-a09e-8e04faf8fddc",
      },
      {
        key: "list_arsimi_parauniversitar",
        url: "https://qbz.gov.al/preview/ccd9b8f7-260f-44d3-bc9b-22bfebf5b0ab/cons/20241216",
      },
      {
        key: "list_licencat",
        url: "https://qbz.gov.al/preview/21b2b631-84b2-4957-b2c1-9be0fddd97b5/cons/20210707",
      },
      {
        key: "list_sinjalizimi",
        url: "https://qbz.gov.al/preview/9ed78881-0c94-4409-9d7c-4a2a44630b2d/cons/20210125",
      },
      {
        key: "list_turizmi",
        url: "https://qbz.gov.al/preview/15cb3247-353b-4b99-a9d5-54a6be2f0b74/cons/20241213",
      },
    ],
  },
  {
    titleKey: "vendime",
    items: [
      {
        key: "list11",
        url: "https://qbz.gov.al/preview/ef1f3e22-dc4b-4205-94f0-e96ad3c87eda/cons/20220127",
      },
      {
        key: "vkm_pagesa_punesia",
        url: "https://qbz.gov.al/preview/48720d72-6c6d-4471-a8fb-8f6ecf4b6527/cons/20230707",
      },
      {
        key: "list13",
        url: "https://qbz.gov.al/preview/0225859e-d622-4a5e-a6a0-638fd8b359a1/cons/20240503",
      },
      {
        key: "list14",
        url: "https://qbz.gov.al/preview/55cc8f13-1eaf-41f2-ae6a-42257d652e6b/cons/20220816",
      },
      {
        key: "list15",
        url: "https://qbz.gov.al/preview/34ea8db8-e626-4055-8695-e89f3a6b5546/cons/20240430",
      },
      {
        key: "list16",
        url: "https://qbz.gov.al/eli/vendim/2020/07/29/608/7153d914-8bb8-4104-9d14-d23c5f24179a",
      },
      {
        key: "vkm_struktura_sinjalizim",
        url: "https://qbz.gov.al/eli/vendim/2016/11/16/816/706b67dd-efab-4135-808c-c07aba584144",
      },
      {
        key: "vkm_sherbimet_punesimit",
        url: "https://qbz.gov.al/preview/b2df7bee-dc40-4cd3-8f16-044c7a6e12ed/cons/20240415",
      },
      {
        key: "vkm_krijim_mbyllje_afp",
        url: "https://qbz.gov.al/eli/vendim/2015/03/04/198/897d751f-2404-4141-a1ce-305481c4010d",
      },
      {
        key: "vkm_mbeshtetje_praktika",
        url: "https://qbz.gov.al/eli/vendim/2013/05/22/500/1fb8da9c-df7f-4f7a-bd81-13dd4164e0c3",
      },
      {
        key: "vkm_kuota_bursa_afp",
        url: "https://qbz.gov.al/preview/877b78fe-4519-4e58-adfc-282ee021b9f2/cons/20220816",
      },
      {
        key: "vkm_paga_mbeshtetes",
        url: "https://qbz.gov.al/preview/66e4f95e-22b8-4c46-bec3-c796325efc36/cons/20241023",
      },
      {
        key: "vkm_hapje_mbyllje_ofrues_afp",
        url: "https://qbz.gov.al/eli/vendim/2023/07/26/454/ce28b587-c8db-4f32-8ee1-0f937a05321a",
      },
      {
        key: "vkm_keshilli_kombetar_afp",
        url: "https://qbz.gov.al/eli/vendim/2018/12/12/729/c95053dc-f089-42e5-93e3-3ffad4cf68f5",
      },
      {
        key: "vkm_lista_profesioneve",
        url: "https://qbz.gov.al/eli/vendim/2009/06/11/627/2461dddc-2994-4964-b9b3-5c50d6dd6884",
      },
      {
        key: "vkm_njohja_nxenit_joformal",
        url: "https://qbz.gov.al/eli/vendim/2021/12/09/756/70c80b39-392a-4811-87d8-3e82d06fa499",
      },
      {
        key: "vkm_kontrata_mesimit_profesionit",
        url: "https://qbz.gov.al/eli/vendim/2024/11/06/691/6bcf98ac-68e7-4eb4-82a9-39b37a411f00",
      },
      {
        key: "vkm_garancia_rinore",
        url: "https://qbz.gov.al/eli/vendim/2023/04/27/264/d94f9d00-8b00-41b8-8e42-318fded2e77b",
      },
      {
        key: "vkm_programet_formimit_prof",
        url: "https://qbz.gov.al/eli/vendim/2022/10/05/646/c589454f-528b-4d29-82e0-cb84622fcd92",
      },
      {
        key: "vkm_certifikata_udherrefyes",
        url: "https://qbz.gov.al/preview/8caa368d-46ad-4f2f-ae81-bb14a5459d58/cons/20240821",
      },
      {
        key: "vkm_agjencite_private_punesimit",
        url: "https://qbz.gov.al/eli/vendim/2018/02/23/101/a41ce3a7-8ae1-43a1-beb3-7582b6c2f4b6",
      },
      {
        key: "vkm_paga_mesimore",
        url: "https://qbz.gov.al/eli/vendim/2024/06/26/425/1b8e16a1-2a01-41ba-a809-7f9da57e2f52",
      },
      {
        key: "vkm_paga_funksionareve",
        url: "https://qbz.gov.al/eli/vendim/2023/05/31/325/0b2165b9-e34d-4962-8ed7-cf4e5634a450",
      },
    ],
  },
  {
    titleKey: "udhezime",
    items: [
      {
        key: "udh_organizimi_ofruesve_afp",
        url: "https://qbz.gov.al/preview/faf0ed7e-9334-409d-85fe-e95346102e62/cons/20241227",
      },
      {
        key: "udh_afp_forma_dyfishte",
        url: "https://qbz.gov.al/eli/udhezim/2024/12/12/1090/8f0037f0-b54c-4fd1-bc0c-a514e11d94a1",
      },
      {
        key: "udh_nxenesit_normat_afp",
        url: "https://qbz.gov.al/eli/udhezim/2023/09/01/25/3c24faa9-d91f-460c-9093-8714d3d9c676",
      },
      {
        key: "udh_bordi_drejtues_afp",
        url: "https://qbz.gov.al/eli/udhezim/2018/07/30/28/83668157-382c-4831-bea8-b60d5277f721",
      },
      {
        key: "udh_procedurat_mesuesit",
        url: "https://qbz.gov.al/preview/a657d2ac-1a71-4d66-9652-186e7639ac4d/cons/20250326",
      },
      {
        key: "udh_certifikatat_afp",
        url: "https://qbz.gov.al/eli/udhezim/2023/03/29/9/31343e8d-e10d-485e-a2a5-3595ceb01f35;q=P%C3%ABr%20llojet,%20pro%C3%A7edurat%20dhe%20m%C3%ABnyrat%20p%C3%ABr%20l%C3%ABshimin%20e%20certifikatave,%20si%20dhe%20formatet%20q%C3%AB%20do%20t%C3%AB%20p%C3%ABrdoren%20n%C3%AB%20sistemin%20e%20Arsimit%20dhe%20Formimit%20Profesional",
      },
      {
        key: "udh_njohja_kualifikimeve",
        url: "https://qbz.gov.al/eli/udhezim/2018/07/30/24/27b27a97-d417-4f6f-ab89-7f2b82958ec5",
      },
      {
        key: "udh_formatet_kurrikulare_afp",
        url: "https://qbz.gov.al/eli/udhezim/2018/07/30/27/bd6e32c3-3e91-417c-a0b1-6ef36279d066",
      },
      {
        key: "udh_vetevleresimi_afp",
        url: "https://qbz.gov.al/preview/97e50a35-6491-436b-935f-f44fb6844bae/cons/20210901",
      },
      {
        key: "udh_katalogu_kualifikimeve",
        url: "https://qbz.gov.al/eli/udhezim/2018/07/30/26/61f66601-41f9-48e2-8901-254eb0951f19",
      },
      {
        key: "udh_kualifikimi_vazhduar_mesuesve",
        url: "https://qbz.gov.al/preview/607a62f4-6bf0-4449-baab-677c14feb0c6/cons/20241105",
      },
      {
        key: "udh_afp_te_denuar",
        url: "https://qbz.gov.al/eli/udhezim/2024/06/24/5/17ac8065-93ca-45a9-98fe-691a7915d677",
      },
      {
        key: "udh_perdorimi_ardhurave_afp",
        url: "https://qbz.gov.al/eli/udhezim/2023/08/02/23/76f92c6c-b402-43dc-8f2a-0ce340f8ca37",
      },
      {
        key: "udh_mesuesi_ndihmes",
        url: "https://qbz.gov.al/eli/udhezim/2019/11/25/26/c29794f5-7719-4e91-b663-b15fa462e264;q=P%C3%ABr%20m%C3%ABsuesin%20ndihm%C3%ABs%20dhe%20ngritjen%20e%20funksionimin%20e%20komisionit%20p%C3%ABr%20nx%C3%ABn%C3%ABsit%20me%20aft%C3%ABsi%20t%C3%AB%20kufizuar%20n%C3%AB%20institucionet%20publike%20t%C3%AB%20arsimit%20profesional",
      },
      {
        key: "udh_licencimi_monitorimi_fp",
        url: "https://qbz.gov.al/eli/udhezim/2024/12/12/1093/0836f546-9b54-4d93-911f-0c3079d786fe",
      },
      {
        key: "udh_transferimi_gjimnaz_afp",
        url: "https://qbz.gov.al/preview/7c94fe24-886a-4c8f-8109-de89e706e017/cons/20241015",
      },
    ],
  },
  {
    titleKey: "urdhera",
    items: [
      { key: "urdh_struktura_akpa" }, // No URL
      {
        key: "urdh_akreditimi_afp",
        url: "https://qbz.gov.al/eli/urdher/2021/07/06/128/0bb764fc-b923-4223-90f7-4ffb50ac0f3d;q=P%C3%ABr%20miratimin%20e%20rregullores%20p%C3%ABr%20standardet,%20kriteret%20dhe%20procedurat%20e%20akreditimit%20t%C3%AB%20ofruesve%20t%C3%AB%20arsimit%20dhe%20formimit%20profesional",
      },
      {
        key: "urdh_katalogu_kualifikimeve",
        url: "https://qbz.gov.al/preview/8b640c14-b550-4e6d-9cce-8eea97b8c3b8/cons/20240912",
      },
      {
        key: "urdh_manuali_mfk",
        url: "https://qbz.gov.al/eli/urdher/2024/01/26/4/08e05655-9dd6-4697-a8dd-e4f97875ff53",
      },
      {
        key: "urdh_sherbimi_psikosocial",
        url: "https://qbz.gov.al/preview/060fa348-d094-4681-82be-be153e394460/cons/20230808",
      },
      {
        key: "urdh_praktika_ne_biznes",
        url: "https://www.akafp.gov.al/wp-content/uploads/2022/12/Regulation-of-Professional-Practices-in-Business_1-1.pdf",
      },
    ],
  },
];

const specificLegalSectionsConfig = [
  {
    titleKey: "laws",
    items: [{ key: "list16" }, { key: "list17" }],
  },
  {
    titleKey: "vendime",
    items: [
      { key: "list1" },
      {
        key: "list11",
        url: "http://akpa.gov.al/wp-content/uploads/2020/08/VKM-nr-554-date-31.07.2019.pdf",
      },
      {
        key: "list13",
        url: "http://akpa.gov.al/wp-content/uploads/2020/08/VKM-17-date-15012020.pdf",
      },
      {
        key: "list14",
        url: "http://akpa.gov.al/wp-content/uploads/2020/08/VKM-348-dt29042020.pdf",
      },
      {
        key: "list15",
        url: "http://akpa.gov.al/wp-content/uploads/2020/08/VKM-Nr.535-date-08.07.2020.pdf",
      },
      {
        key: "list16",
        url: "http://akpa.gov.al/wp-content/uploads/2020/08/VKM-608-e-C19.pdf",
      },
    ],
  },
];

const TermsAndConditions = ({ language = {} }) => {
  const createListItemElement = (item, index) => {
    const text = language[item.key];

    if (!text) {
      console.warn(`Missing language key: ${item.key}`);
      return null;
    }

    const isValidUrl =
      item.url && (item.url.startsWith("http") || item.url.startsWith("https"));

    if (isValidUrl) {
      return (
        <li key={`${item.key}-${index}`}>
          {" "}
          {/* Use index for a more unique key */}
          <a
            href={item.url}
            target="_blank"
            rel="noopener noreferrer"
            style={{
              textDecoration: "underline",
              color: "blue" /* Example style */,
            }}
          >
            {text}
          </a>
        </li>
      );
    } else {
      return <li key={`${item.key}-${index}`}>{text}</li>;
    }
  };
  return (
    <div className="pb-16 text-gray-700">
      <div className="bg-gradient-to-b from-gray-200 to-white pt-16 pb-10">
        <section className="max-w-6xl mx-auto">
          <div className=" mb-8">
            {/* Title */}
            <h2 className="text-red-600 mb-5 font-semibold text-4xl">
              {language.title}
            </h2>
            <p className="mb-5">{language.description}</p>
          </div>
        </section>

        {legalSectionsConfig.map((section) => (
          <section key={section?.titleKey} className="max-w-6xl mx-auto">
            <div className=" bg-white border border-gray-100 rounded-xl p-8 mb-8 shadow-custom">
              <h2 className="text-red-600 mb-5 font-semibold text-2xl">
                {language[section.titleKey]}
              </h2>
              <ul style={{ listStyle: "disc", paddingLeft: "20px" }}>
                {section.items.map((item, itemIndex) =>
                  createListItemElement(item, itemIndex),
                )}
              </ul>
            </div>
          </section>
        ))}

        <section className="max-w-6xl mx-auto">
          {/* Title */}
          <h2 className="text-red-600 mb-2 font-semibold text-2xl">
            {language.pageTitle2}:
          </h2>
        </section>

        {specificLegalSectionsConfig.map((section, sectionIndex) => (
          <section key={section?.titleKey} className="max-w-6xl mx-auto">
            <div className=" bg-white border border-gray-100 rounded-xl p-8 mb-8 shadow-custom">
              <h2 className="text-red-600 mb-5 font-semibold text-2xl">
                {language[section.titleKey]}
              </h2>
              <ul style={{ listStyle: "disc", paddingLeft: "20px" }}>
                {section.items.map((item, itemIndex) =>
                  createListItemElement(item, itemIndex),
                )}
              </ul>
            </div>
          </section>
        ))}
      </div>
    </div>
  );
};

export default withLanguage(TermsAndConditions, "termsAndConditions");
